<template>
  <nx-bform-group 
  :label="requiredLabel(name)" 
  v-bind="$attrs"
  :description="defaultDescription"
  >
    <slot>
      <nx-bform-input
        :name="name"
        :rules="{ required }"
        :value="$attrs.value"
        @input="$listeners.input"
      />
    </slot>
  </nx-bform-group>
</template>

<script>
import FormGroupMixin from "../form-group.mixin";

export default {
  props: {
    description: {
      type: String
    },
    message: {}
  },  
  mixins: [FormGroupMixin],
  computed: {
    name() {
      return this.label || this.$t("post");
    },
    defaultDescription() {
      return this.message === "true"
        ? this.$t("postDesc")
        : null;
    }
  }
};
</script>

<i18n src="@/locales/login.locale.json" />
